'use client'

import { Loader2Icon } from 'lucide-react'
import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

function Spinner({ className, ...props }: ComponentProps<'svg'>) {
  const { t } = useTranslation()

  return (
    <Loader2Icon aria-label={t('Loading')} className={cn('size-4 animate-spin', className)} role="status" {...props} />
  )
}

export { Spinner }
